import { useAuthSession } from '../lib/session.ts';
import { ProfilePicker } from './ProfilePicker.tsx';
import { Landing } from './Landing.tsx';

/** The '/' route. Local (prototype) store keeps the original behaviour: straight to the profile
 * picker (it is always "signed in"). With an account backend, an anonymous visitor sees the
 * marketing landing page instead; the picker only appears once we know there's a session. */
export function Entry() {
  const { status } = useAuthSession();
  if (status === 'loading') return <div className="min-h-dvh" />;
  return status === 'signed_in' ? <ProfilePicker /> : <Landing />;
}
